/*
  Numerology helpers — the Basic/Birth Number comes from the DAY
  of birth only (not month or year), reduced to a single digit.
*/

export const PLANET_BY_NUMBER = {
  1: 'Sun',
  2: 'Moon',
  3: 'Jupiter',
  4: 'Rahu',
  5: 'Mercury',
  6: 'Venus',
  7: 'Ketu',
  8: 'Saturn',
  9: 'Mars',
};

export const PLANET_EMOJI = {
  Sun: '☀️',
  Moon: '🌙',
  Mars: '🔴',
  Mercury: '💚',
  Jupiter: '🟡',
  Venus: '💗',
  Saturn: '🟣',
  Rahu: '🟠',
  Ketu: '🔵',
};

/* Reduce a day-of-month (1–31) to a single digit 1–9. */
export const calculateBirthNumber = (day) => {
  let sum = Number(day);
  if (!sum || Number.isNaN(sum)) return null;

  while (sum > 9) {
    sum = String(sum)
      .split('')
      .reduce((total, digit) => total + Number(digit), 0);
  }
  return sum;
};

/* Accepts an ISO date string ("1998-07-21") or a Date. */
export const birthNumberFromDate = (date) => {
  if (!date) return null;

  const day =
    typeof date === 'string'
      ? Number(date.split('-')[2])
      : new Date(date).getDate();

  return calculateBirthNumber(day);
};

export const planetFromNumber = (number) => PLANET_BY_NUMBER[number] || null;

export const planetFromDate = (date) => planetFromNumber(birthNumberFromDate(date));
